module.exports = __webpack_public_path__ + "img/mercs-for-money.49cd0db0.svg";